import React from "react";
import styled from "styled-components";

interface Props {
    text?: string;
    icon?: React.FC;
    onClickHandler?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const MenuButton: React.FC<Props> = ({ text, icon: Icon, onClickHandler }) => {
    if (Icon && !text)
        return (
            <IconItem onClick={onClickHandler}>
                <Icon />
            </IconItem>
        );

    return (
        <Container onClick={onClickHandler}>
            {Icon ? <Icon /> : null}
            {text ? <span>{text.toUpperCase()}</span> : null}
        </Container>
    );
};

const Container = styled.div`
    display: flex;

    justify-content: center;
    align-items: center;

    min-width: 7rem;
    height: 2.6rem;

    font-size: 0.9rem;
    font-weight: ${(props) => props.theme.fontWeight.bolder};

    color: ${(props) => props.theme.colors.primary[300]};
    background: white;
    box-shadow: 1px 0px 10px 1px rgba(231, 231, 231, 0.5);

    border-radius: 0.2rem;

    &:hover {
        background: ${(props) => props.theme.colors.primary[100]};
        color: white;
        cursor: pointer;

        &:first-child {
            & > *:first-child {
                & > * {
                    stroke: ${(props) => props.theme.colors.neutral[100]};
                }
            }
        }
    }

    &:first-child {
        & > *:first-child {
            & > * {
                stroke: ${(props) => props.theme.colors.primary[300]};
            }
        }
    }

    & > *:first-child {
        margin-right: 10px;
    }
`;

const IconItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    height: 2.6rem;
    min-width: 2.6rem;

    color: ${(props) => props.theme.colors.primary[300]};
    background: white;
    box-shadow: 1px 0px 10px 1px rgba(231, 231, 231, 0.5);

    border-radius: 0.2rem;

    font-size: 0.9rem;

    &:hover {
        background: ${(props) => props.theme.colors.primary[100]};
        color: white;
        cursor: pointer;

        &:first-child {
            & > *:first-child {
                & > * {
                    stroke: ${(props) => props.theme.colors.neutral[100]};
                }
            }
        }
    }
`;

export default MenuButton;
